import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    main: {
      width: '39rem',
      padding: '2.4rem 1.6rem',
      boxShadow: '0 .4rem .4rem 0 #00000040',
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
  }),
)
